var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"demo__flex demo__margin-bottom--24",class:{
      'demo__flex-middle': !_vm.isMobile,
      'demo__flex-column': _vm.isMobile,
    }},[_c('div',{staticClass:"demo__font--20 demo__weight--600 demo__color--black demo__margin-right--16"},[_vm._v(" "+_vm._s(_vm.$t("Reg for users " + _vm.step))+" ")]),_c('div',{staticClass:"demo__font--11 demo__weight--500 demo__color--textPrimaryGray",class:{
        'demo__margin-top--8': _vm.isMobile,
      }},[_vm._v(" "+_vm._s(_vm.$t("Step"))+" "+_vm._s(_vm.step)+" "+_vm._s(_vm.$t("from"))+" "+_vm._s(_vm.maxStepsCount)+" ")])]),_c('Step' + _vm.step,{tag:"component",attrs:{"form":_vm.form,"reg-result":_vm.regResult}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }